import { baseApi } from "../baseApi";

export const purchasereturnbulkApi = baseApi.injectEndpoints({
     endpoints: (builder) => ({
    getScanItem: builder.query({
      query: (params) => ({
        url: `/api/method/stackerbee_mobile_wms.stackerbee_mobile_wms.doctype.purchase_return_bulk.purchase_return_bulk.handle_scan_item`,
        params
      })
    }),
    postCreateBulkPurchaseOrder: builder.mutation({
      query: (data) => ({
        url: `/api/resource/Purchase Return Bulk`,
        method: 'post',
        body: data
      })
    }),
    postSubmitBulkPurchaseOrder: builder.mutation({
      query: (data) => ({
        url: `/api/method/frappe.desk.form.save.savedocs`,
        method: 'post',
        params: data
      })
    }),
    postCreateBulkPickList: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.stackerbee_mobile_wms.doctype.purchase_return_bulk.purchase_return_bulk.create_pick_list`,
        method: 'post',
        params: data
      })
    }),
    getBulkPickListDetail: builder.query({
      query: (params) => ({
        url: `/api/method/frappe.desk.form.load.getdoc`,
        params
      })
    }),
  }),
});

export const { useGetScanItemQuery, usePostCreateBulkPurchaseOrderMutation,usePostSubmitBulkPurchaseOrderMutation,usePostCreateBulkPickListMutation,useGetBulkPickListDetailQuery } = purchasereturnbulkApi;

